<template>
  <v-dialog
    v-model="showModal"
    persistent
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">{{getTitle}}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-row>
          <v-col cols="12" md="12">
            <el-simple-table :items="logDataList" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          title="Atgal"
          :loading="loading"
          @click.native.stop="closeModal()"
          color="secondary"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalBrokerLogs',
  props: {
    item: Object,
    value: Boolean,
    loading: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {}
  },
  computed: {
    getTitle() {
      return `Duomenų perdavimas JAR`
    },
    logDataList() {
      return [
        {
          title: 'UUID',
          value: this.item?.uuid || '',
          trStyle: 'white-space: break-spaces;'
        },
        {
          title: 'Pakartotinio perdavimo duomenys',
          value: this.item?.payload_data || '',
          html: true,
        },
        {
          title: 'Klaida',
          value: this.item?.exception || '',
        },
        {
          title: 'Klaidos data ir laikas',
          value: this.item?.failed_at || '',
        },
      ]
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.showModal = false
    },

    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped></style>
